import { InputAdornment } from "@mui/material";
import { DateField } from "@mui/x-date-pickers-pro";
import { DateTime } from "luxon";
import { blue, neutral, CalendarIcon } from "@flat-ui";

const HELPER_TEXT_CLASS_NAME = "helper-class";

interface Props {
  /** Callback when the date field is confirmed by pressing the enter button */
  onConfirmed: (date: DateTime | null) => void;

  /** Callback when the date is changed by typing it (not confirming it yet) */
  onChange: (date: DateTime | null) => void;

  /** The date to be shown as the current date */
  date: DateTime | null;
}

/** The date text field allows user to type in a date */
export function FaroDateTextField({
  onChange,
  onConfirmed,
  date,
}: Props): JSX.Element {
  return (
    <DateField
      sx={{
        width: "320px",
        height: "34px",
        borderBottom: `2px solid ${neutral[100]}`,
        [`& .${HELPER_TEXT_CLASS_NAME}`]: {
          visibility: "hidden",
        },
        "&:hover": {
          borderBottom: `2px solid ${neutral[1000]}`,
          [`& .${HELPER_TEXT_CLASS_NAME}`]: {
            visibility: "visible",
          },
        },
        "&:focus-within": {
          borderBottom: `2px solid ${blue[500]}`,
          [`& .${HELPER_TEXT_CLASS_NAME}`]: {
            visibility: "visible",
          },
        },
        justifyContent: "center",
        m: "12px",
      }}
      variant="standard"
      value={date}
      fullWidth
      autoFocus
      InputProps={{
        // eslint-disable-next-line @typescript-eslint/naming-convention
        disableUnderline: true,

        startAdornment: (
          <InputAdornment position="start">
            <CalendarIcon sx={{ height: "18px", color: neutral[500] }} />
          </InputAdornment>
        ),
        endAdornment: (
          <InputAdornment position="end" className={HELPER_TEXT_CLASS_NAME}>
            <p style={{ fontSize: "10px" }}>Type and press enter</p>
          </InputAdornment>
        ),
      }}
      onChange={onChange}
      onKeyDown={(event) => {
        if (event.key === "Enter") {
          onConfirmed(date);
        }
      }}
    />
  );
}
